(function() {
    'use strict';
    var DisplayMessageThreadBaseCtrl = function (returnRoute, returnOpts) {
        return function ($scope, $stateParams, $sce, $anchorScroll, $location, PatientPortalStorageRepository, MyMessagesRepository, MyMessagesService, $log, TransitionManager, toaster, gettext, MetadataRepository, NotificationService, MyChartService) {
            $scope.loading = false;
            $scope.replying = false;

            $scope.thumbnailSrc = MyChartService.getMaleThumbnailSrc(50,50);

            $scope.messageThread = {
                Messages: null,
                NumberOfMessages: 0,
                DisplayMode: ''
            };
            var activePatient = PatientPortalStorageRepository.getActivePatient();

            var updateNotifications = false;

            if ($stateParams.displayMode.toUpperCase() === 'RECEIVED') {
                $scope.panelHeadingText = gettext('Received Messages');
                $scope.allowReply = true;
                $scope.messageThread.DisplayMode = 'Received';

                if ($stateParams.updateNotification && $stateParams.updateNotification.toUpperCase() === 'TRUE') {
                        updateNotifications = true;
                }
            }
            else if ($stateParams.displayMode.toUpperCase() === 'SEND') {
                $scope.panelHeadingText = gettext('Sent Messages');
                $scope.allowReply = false;
                $scope.messageThread.DisplayMode = 'Send';
            }
            else {
                $scope.panelHeadingText = gettext('Unknown display mode - ') + $stateParams.displayMode;
                $scope.allowReply = false;
                $scope.messageThread.DisplayMode = 'Unknown';
            }

            $scope.portalMessage = {
                Message: ''
            };

            function loadView() {
                if ($scope.messageThread.DisplayMode.toUpperCase() !== 'UNKNOWN') {
                    $scope.loading = true;
                    $scope.removeHttpError();
                    MyMessagesRepository
                        .getMessageThreadMessages(activePatient.id, $stateParams.id)
                        .then(function (data) {
                            $scope.messageThread.Messages = _(data)
                                .forEach(function (msg) {
                                    msg.MessageHeaderText = MyMessagesService.cleanMessageHeader(msg.MessageHeaderText);
                                    msg.MessageBodyTextNoLineBreaks = $sce.trustAsHtml(MyMessagesService.removeLineBreaks(msg.MessageBodyText));
                                    msg.MessageBodyText = $sce.trustAsHtml(msg.MessageBodyText);
                                    msg.IsCollapsed = true;
                                });

                            $scope.messageThread.NumberOfMessages = $scope.messageThread.Messages.length;

                            if ($scope.messageThread.NumberOfMessages > 0) {
                                $scope.messageThread.Messages[$scope.messageThread.NumberOfMessages - 1].IsCollapsed = false;

                                return MyMessagesService.getMessageSettings(activePatient.id)
                                    .then(function (data) {
                                        var msgSetting = _.find(data[0].MessageSubTypes, { Id: $scope.messageThread.Messages[0].MessageSubTypeId });
                                        if (msgSetting) {
                                            $scope.allowReply = (msgSetting.CanBeSentByPatient && !msgSetting.SystemMessage);
                                        }
                                    });
                            }
                            else {
                                $scope.allowReply = false;
                            }

                            if (updateNotifications) {
                                updateNotifications = false;
                                NotificationService.updateNotifications();
                            }
                        })
                        .catch(function (response) {
                            $scope.addHttpError(response);
                        })
                        .finally(function () {
                            $scope.loading = false;
                            $location.hash('display-messages-bottom');
                            $anchorScroll();
                        });
                }

                MetadataRepository.getMetadata('createportalmessage', $scope);
            }

            $scope.replyToMessage = function replyToMessage(form) {
                if (! $scope.allowReply) {
                    return;
                }

                form.isSubmitted = true;

                if (form.$valid) {
                    $scope.replying = true;

                    var newMessage  = {
                        MessageBody: MyMessagesService.replaceLineBreaksWithHtmlLineBreak($scope.portalMessage.Message),
                        ParentMessageId: $stateParams.id,
                        PatientId: activePatient.id
                    };

                    MyMessagesRepository
                        .replyToMessage(activePatient.id, newMessage)
                        .then(function () {
                            TransitionManager.transition({appRoute: returnRoute, opts: returnOpts });
                            toaster.pop('success', '', gettext('Message sent successfully.'));
                        })
                        .catch(function () {
                            toaster.pop('error', '', gettext('An error has occurred and the Message was not sent.'));
                        })
                        .finally(function () {
                            $scope.replying = false;
                        });
                }
            };

            loadView();
        };
    };
    var DisplayMessageThreadCtrl = new DisplayMessageThreadBaseCtrl('myMessagesDisplayMessages', { displayMode: 'received' });
    var DisplayMessageThreadMobileCtrl = new DisplayMessageThreadBaseCtrl('myMessagesMobile', { folder: 'inbox' });
    angular.module('mymessages').controller('DisplayMessageThreadCtrl',
    ['$scope', '$stateParams', '$sce', '$anchorScroll', '$location', 'PatientPortalStorageRepository', 'MyMessagesRepository', 'MyMessagesService', '$log', 'TransitionManager', 'toaster', 'aprgettext', 'MetadataRepository', 'NotificationService', 'MyChartService',
        DisplayMessageThreadCtrl]);
    angular.module('mymessages').controller('DisplayMessageThreadMobileCtrl',
    ['$scope', '$stateParams', '$sce', '$anchorScroll', '$location', 'PatientPortalStorageRepository', 'MyMessagesRepository', 'MyMessagesService', '$log', 'TransitionManager', 'toaster', 'aprgettext', 'MetadataRepository', 'NotificationService', 'MyChartService',
        DisplayMessageThreadMobileCtrl]);
})();